import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiFunction, URL } from "./utils";

const deviceApi = createApi({
  reducerPath: "devices",
  baseQuery: fetchBaseQuery({
    baseUrl: `${URL.url}`,
    fetchFn: async (...args) => {
      // REMOVE FOR PRODUCTION
      return fetch(...args);
    },
  }),
  tagTypes: ["Devices"],
  endpoints: (builder) => ({
    // Tüm cihazları listele
    getAllDevices: builder.query({
      query: (data) => {
        return apiFunction(data, "/api/medicine-devices/getAllDevices", "POST");
      },
      providesTags: ["Devices"],
    }),

    // Tek bir cihazı getir
    getDevice: builder.query({
      query: (data) => {
        return apiFunction(data, "/api/medicine-devices/getDevice", "POST");
      },
      providesTags: ["Devices"],
    }),

    // Yeni cihaz oluştur
    createDevice: builder.mutation({
      query: (data) => {
        return apiFunction(data, "/api/medicine-devices/createDevice", "POST");
      },
      invalidatesTags: ["Devices"],
    }),

    // Cihazı hastaya ata
    assignToPatient: builder.mutation({
      query: (data) => {
        return apiFunction(
          data,
          "/api/medicine-devices/assignToPatient",
          "POST"
        );
      },
      invalidatesTags: ["Devices"],
    }),

    // Cihazı servise ata
    assignToService: builder.mutation({
      query: (data) => {
        return apiFunction(
          data,
          "/api/medicine-devices/assignToService",
          "POST"
        );
      },
      invalidatesTags: ["Devices"],
    }),

    // Cihazı depoya ata
    assignToDepot: builder.mutation({
      query: (data) => {
        return apiFunction(data, "/api/medicine-devices/assignToDepot", "POST");
      },
      invalidatesTags: ["Devices"],
    }),

    // Cihaz sil
    deleteDevice: builder.mutation({
      query: (data) => {
        return apiFunction(data, "/api/medicine-devices/deleteDevice", "POST");
      },
      invalidatesTags: ["Devices"],
    }),
  }),
});

export const {
  useLazyGetAllDevicesQuery,
  useLazyGetDeviceQuery,
  useCreateDeviceMutation,
  useAssignToPatientMutation,
  useAssignToServiceMutation,
  useAssignToDepotMutation,
  useDeleteDeviceMutation,
} = deviceApi;

export { deviceApi };
